/**
 * Typesense filter for the characters using a Rulebook in this app. The host passes its NSFW exclusion clause when the
 * viewer filters NSFW content, since the NSFW tag list is platform configuration.
 */
const buildRulebookBotsFilter = ({ rulebookId, applicationId, nsfwExclusionFilter, }) => {
    const filter = `rulebook_id:=${rulebookId} && application_ids:${applicationId}`;
    return nsfwExclusionFilter ? `${filter} && ${nsfwExclusionFilter}` : filter;
};
export default buildRulebookBotsFilter;
